import { useEffect, type ComponentType } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { useUser } from "@/hooks/useUser";
import LoadingScreen from "@/components/LoadingScreen";
import { InteractionStatus } from "@azure/msal-browser";

const withAuth = <T extends object>(WrappedComponent: ComponentType<T>) => {
  return (props: T) => {
    const { inProgress } = useMsal();
    const navigate = useNavigate();
    const { isLoading, data } = useUser();
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
      if (!isLoading && inProgress === InteractionStatus.None) {
        if (!isAuthenticated) {
          const url = window.location.href;

          sessionStorage.setItem("redirectPath", url);
          navigate("/sso");
        } else if (!data?.id) {
          navigate("/");
        }
      }
    }, [isLoading, inProgress, isAuthenticated, data?.id, navigate]);

    if (isLoading || inProgress !== InteractionStatus.None) {
      return <LoadingScreen />;
    } else if (!isAuthenticated) {
      return null;
    } else {
      return <WrappedComponent {...props} />;
    }
  };
};

export default withAuth;
